import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import { AssistanceBill } from '../../../models/assistance-bill';
import {Country} from '../../../models/country';

@Component({
    selector: 'charge-assistance-bill-form',
    templateUrl: './charge-assistance-bill-form.component.html',
    styleUrls: ['./charge-assistance-bill-form.component.css'],
    standalone: false
})
export class ChargeAssistanceBillFormComponent implements OnInit, OnChanges {

  priceBilled?: number = null;
  @Input() bill?: AssistanceBill;
  @Input() disabled: EventEmitter<boolean>;
  @Input() country: Country;
  @Output() charge = new EventEmitter<AssistanceBill>();
  @ViewChild('form') form;
  inputFocused = new EventEmitter<boolean>();
  isDisabled = false;

  onSubmit() {
    this.isDisabled = true;
    this.bill.price_billed = this.priceBilled;
    this.charge.emit(this.bill);
    this.reset();
  }

  reset() {
    this.priceBilled = null;
    this.form.reset();
  }

  ngOnInit() {
    if (this.disabled) {
      this.disabled.subscribe(disabled => {
        this.isDisabled = disabled;
      });
    }
  }
  ngOnChanges(changes: any) {
    this.inputFocused.emit(true);
  }
}
